var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudieLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.21 134.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#New_Gradient_Swatch_copy_8-2);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-4 {\n        opacity: .5;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#New_Gradient_Swatch_copy_8-3);\n      }\n\n      .cls-6 {\n        opacity: .75;\n      }\n\n      .cls-7 {\n        fill: none;\n      }\n\n      .cls-8 {\n        fill: #bcbcbc;\n      }\n\n      .cls-3 {\n        fill: url(#New_Gradient_Swatch_copy_8-4);\n      }\n\n      .cls-9 {\n        opacity: .25;\n      }\n\n      .cls-10 {\n        fill: url(#New_Gradient_Swatch_copy_8);\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    "data-name": "New Gradient Swatch copy 8",
    x1: 5,
    y1: 67.18,
    x2: 143.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 67.18,
    x2: 148.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    "data-name": "New Gradient Swatch copy 8",
    x1: 5,
    x2: 143.21,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-3",
    "data-name": "New Gradient Swatch copy 8",
    x1: 13.97,
    y1: 68.06,
    x2: 143.21,
    y2: 68.06,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-4",
    "data-name": "New Gradient Swatch copy 8",
    x1: 34.72,
    y1: 85.6,
    x2: 143.21,
    y2: 85.6,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m99.95,5h-51.69c-6.22,0-11.97,3.32-15.08,8.71L7.33,58.47c-3.11,5.39-3.11,12.03,0,17.42l25.85,44.77c3.11,5.39,8.86,8.71,15.08,8.71h51.69c6.22,0,11.97-3.32,15.08-8.71l25.85-44.77c3.11-5.39,3.11-12.03,0-17.42l-25.85-44.77c-3.11-5.39-8.86-8.71-15.08-8.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.95,129.37h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m140.88,75.89l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27C51.58,64.48,83.82,38.25,107.56,6.76c3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.95,129.37h-51.69c-5.31,0-10.29-2.42-13.54-6.49,40.54-21.41,73.73-47.76,96.55-81.04l9.61,16.64c3.11,5.39,3.11,12.03,0,17.41l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m140.88,75.89l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m74.08,80.36c-.9,0-1.8-.18-2.65-.53l-24.33-10.13v18.24c0,3.46,3.19,6.05,9.44,7.69,4.69,1.22,10.92,1.89,17.57,1.89,4.52,0,27.01-.46,27.01-9.58v-18.24l-24.36,10.13c-.85.35-1.78.53-2.68.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m117.34,55.4c-.12-.28-.28-.53-.49-.74-.12-.12-.21-.21-.35-.28-.12-.09-.25-.16-.39-.21l-.02-.02-41.12-17.11c-.58-.25-1.2-.25-1.78,0l-41.09,17.11c-.85.37-1.41,1.2-1.41,2.12s.55,1.78,1.41,2.15l41.09,17.13c.28.12.58.18.88.18s.62-.07.9-.18l37.93-15.79v14.08c0,1.27,1.04,2.31,2.31,2.31s2.31-1.04,2.31-2.31v-17.57c0-.16-.02-.3-.05-.44-.02-.16-.07-.3-.14-.44h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudieLocked);
export default __webpack_public_path__ + "static/media/studie_locked.42343dd548a1b15561ee9fb18151d68a.svg";
export { ForwardRef as ReactComponent };